import React from "react";
import { FormattedMessage } from "react-intl";
export const CompletedColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${ObjectCssClasses[(+row.completed)]
      } label-inline`}
  >
    <FormattedMessage id={ObjectTitles[(+row.completed)]} />
  </span>
);


export const ObjectCssClasses = ["info", "success"];
export const ObjectTitles = ["MODULES.GENERAL.NONCOMPLETED", "MODULES.GENERAL.COMPLETED"];